// @flow
import * as React from 'react'
import { TabsContainer } from './elements'

// Types
import type { CommonTabProps } from './Tab'

export type Value = any
export type Props = CommonTabProps & {
  onChange?: Function,
  activeTab?: Value,
  initialActiveTab?: Value,
  children: ?React.Node,
}
type State = {
  activeTab?: Value,
}

class Tabs extends React.Component<Props, State> {
  state = {
    activeTab: this.props.initialActiveTab,
  }

  get activeTab() {
    return this.props.activeTab || this.state.activeTab
  }

  handleSelect = (value: Value) => {
    if (!this.props.activeTab) {
      this.setState({ activeTab: value })
    }

    const { onChange } = this.props
    onChange && onChange(value)
  }

  render() {
    const {
      appearance,
      indicatorColor,
      tabColor,
      activeTabColor,
      children,
      ...others
    } = this.props

    const renderedTabs = React.Children.map(children, (child, index) => {
      if (!child) return null
      const tabValue = child.props.value || index
      const isActive =
        typeof this.activeTab !== 'undefined'
          ? this.activeTab === tabValue
          : index === 0

      return React.cloneElement(child, {
        appearance,
        key: index,
        value: tabValue,
        onSelect: this.handleSelect,
        isActive,
        indicatorColor,
        tabColor,
        activeTabColor,
      })
    })

    return (
      <TabsContainer
        role="tablist"
        aria-orientation="horizontal"
        tabindex="0"
        $appearance={appearance}
        {...others}
      >
        {renderedTabs}
      </TabsContainer>
    )
  }
}

export default Tabs
